import React, { SVGProps } from 'react'
const SvgHourglass = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <g fill={props.fill || 'var(--color-cta)'} fillRule="nonzero">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 6.76C15 6.89 14.95 7.02 14.86 7.11L13.5934 8.40016L12.44 9.62C12.27 9.81 12.26 10.11 12.44 10.3L14.87 12.96C14.95 13.05 15 13.18 15 13.3V16C15 16.55 14.55 17 14 17H6C5.45 17 5 16.55 5 16V13.3C5 13.17 5.05 13.05 5.13 12.96L7.56 10.32C7.74 10.13 7.74 9.83 7.56 9.64L5.14 7.11C5.05 7.01 5 6.89 5 6.76V4C5 3.45 5.45 3 6 3H14.03C14.56 3 15 3.45 15 4V6.76ZM13.87 13.37L11.39 10.65V10.64C11.03 10.26 11.04 9.66 11.4 9.28L13.86 6.7C13.95 6.61 14 6.49 14 6.36V4.5C14 4.22 13.78 4 13.5 4H6.5C6.22 4 6 4.22 6 4.5V6.36C6 6.48 6.05 6.61 6.14 6.7L8.6 9.3C8.96 9.68 8.96 10.27 8.61 10.66L6.13 13.37C6.05 13.46 6 13.59 6 13.71V15.51C6 15.79 6.22 16.01 6.5 16.01H13.5C13.78 16.01 14 15.79 14 15.51V13.71C14 13.58 13.95 13.46 13.87 13.37ZM12.5 5.38V5.91C12.5 6.01 12.46 6.1 12.38 6.17L10.5 7.87C10.21 8.13 9.78 8.13 9.49 7.87L7.62 6.17C7.54 6.1 7.5 6.01 7.5 5.92V5.38C7.5 5.17 7.7 5 7.95 5H12.05C12.3 5 12.5 5.17 12.5 5.38Z"
        fill="#4489F9"
      />
    </g>
  </svg>
)
export default SvgHourglass
